import { render, staticRenderFns } from "./TimeReceivedWithStatus.vue?vue&type=template&id=48a55da6&scoped=true"
import script from "./TimeReceivedWithStatus.vue?vue&type=script&lang=js"
export * from "./TimeReceivedWithStatus.vue?vue&type=script&lang=js"
import style0 from "./TimeReceivedWithStatus.vue?vue&type=style&index=0&id=48a55da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a55da6",
  null
  
)

export default component.exports